<template>
    <div id="inter_list">
        <p v-for="(item,index) in data" :key="index" :class="styleColor == index ?'styleCol':''" @click="rightBtn(index)">{{item}}</p>
    </div>
</template>

<script>
export default {
    data(){
        return{
           data:'',
           styleColor:0,
        }
    },
    props: {
      childData: Array
    },
    mounted() {
      this.data = this.childData
    },
    methods:{
        rightBtn(index){
            this.styleColor = index
            this.Submit(index+1)
        },
         Submit (key) {
              // 获取点击的按钮对应页面的id
              var PageId = document.querySelector('#page' + key)
              // 打印出对应页面与窗口的距离
              // 使用平滑属性，滑动到上方获取的距离
              window.scrollTo({
              'top': PageId.offsetTop,
              'behavior': 'smooth'
              })
        },
    }
}
</script>

<style lang="less" scoped>
    #inter_list{
        margin-bottom:10px;
    }
    p{
        width: 100%;
        border-bottom:1px solid #e4e7ed;
        margin: 0;
        padding: 10px 0;
        cursor: pointer;
    }
    p.styleCol{
        color: #17b9c0;
    }
</style>